import React, { useEffect, useState } from "react";
import "./Components.css";  // optional CSS

const SERVICES = Array.from({ length: 10 }, (_, i) => i + 1);
const DEFAULT_SELECTED = Array.from({ length: 10 }, (_, i) => i + 1); // 1 to 21

function ServicesGrid({ selectedServices, onChange }) {
  // Initialize selected services with default values if undefined
  const [chosen, setChosen] = useState(
    new Set(Array.isArray(selectedServices) ? selectedServices : DEFAULT_SELECTED)
  );
  
  useEffect(() => {
    setChosen(new Set(Array.isArray(selectedServices) ? selectedServices : DEFAULT_SELECTED));
  }, [selectedServices]);  

  function toggleService(num) {
    const newSet = new Set(chosen);
    if (newSet.has(num)) {
      newSet.delete(num);
    } else {
      newSet.add(num);
    }
    setChosen(newSet);
    onChange(Array.from(newSet)); // Notify parent component
  }

  return (
    <div className="services-grid">
      {SERVICES.map((num) => {
        const isActive = chosen.has(num);
        return (
          <div
            key={num}
            className={`service-cell ${isActive ? "active" : ""}`}
            onClick={() => toggleService(num)}
          >
            {num}
          </div>
        );
      })}
    </div>
  );
}

export default ServicesGrid;
